<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			Services
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
			  <span class="sub-menu" routerLink="/home-page">Home </span>&nbsp;/&nbsp;
			  <!-- <span class="sub-menu sub-menu-text font-weight-bold">Custom Software Development</span>&nbsp;/&nbsp; -->
			  <span class="sub-menu" routerLink="/ourproducts"> Our Projects and Experience</span>
			</h5>
		  </div>
		</div>
	   </div>
	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">
        <img src="../../assets/img/verticals/m1.jpg" alt="Sample Image">
        <p>
            "Soar above the ordinary, explore the extraordinary.
A drone unlocks new horizons, reshaping how we see the world.
From breathtaking landscapes to intricate details, it captures all.
Innovation takes flight, bringing efficiency and creativity together.
For your business, it’s not just technology—it’s perspective."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m2.jpg" alt="Sample Image">
        <p>
			"Through the lens, we capture the soul of every moment.
			A camera is more than a tool; it’s a storyteller’s best ally.
			Freeze time, frame emotions, and create lasting impressions.
			Every click tells a story, every image speaks a thousand words.
			In business and art, the camera bridges vision and reality."
			
			
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m3.jpg" alt="Sample Image">
        <p>
			"Every production is a masterpiece of collaboration.
			Cast and crew are the heartbeat of every successful story.
			Behind the scenes lies the true magic of teamwork and dedication.
			Together, they turn ideas into reality and visions into legacies.
			A business thrives when its team works like a well-directed set."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m4.jpg" alt="Sample Image">
        <p>
			"Editing is where the magic unfolds, frame by frame.
It’s the craft of shaping raw content into compelling narratives.
Every cut, transition, and effect breathes life into stories.
In business, polished visuals speak louder than words.
Video editing transforms imagination into a masterpiece."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m5.jpg" alt="Sample Image">
        <p>
			"Advertising is storytelling with a purpose.
			An ad shoot brings brands to life, connecting them with audiences.
			From script to screen, every detail builds a memorable experience.
			Creativity, strategy, and passion come together in perfect harmony.
			Elevate your brand through visual artistry and storytelling brilliance."
        </p>
    </div>
	  
	<!-- <div class="container p-4">
		<h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
			verticals
		  </h4>
		<div class="row animatable fadeInUp">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-medkit service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hospital Management System
						</h6>
						<p class="text-muted">
							Health Care.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-dashboard service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Temple Management System
						</h6>
						<p class="text-muted">
							Religious. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-hotel service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hotel Management System
						</h6>
						<p class="text-muted">
							Restaurants. 
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row  animatable fadeInUp">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							School Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							college Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-users service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Value Added Services
						</h6>
						<p class="text-muted">
							Bio metric Solutions.
							Bio metric Solutions.
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row  animatable fadeInUp">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center icon-border">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Chits Management.
							Jewellery Management.
							Bakery Management 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Pawn Broking.
							Whole Sale Management.
							Textile Management.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Furniture Management.
							Super market Management. 
						</p><br />
					</div>
				</div>
			</div>
		</div>
	</div> -->
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">

	<div class="content-container">
        <img src="../../assets/img/verticals/m1.jpg" alt="Sample Image">
        <p>
            "Soar above the ordinary, explore the extraordinary.
A drone unlocks new horizons, reshaping how we see the world.
From breathtaking landscapes to intricate details, it captures all.
Innovation takes flight, bringing efficiency and creativity together.
For your business, it’s not just technology—it’s perspective."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m2.jpg" alt="Sample Image">
        <p>
			"Through the lens, we capture the soul of every moment.
			A camera is more than a tool; it’s a storyteller’s best ally.
			Freeze time, frame emotions, and create lasting impressions.
			Every click tells a story, every image speaks a thousand words.
			In business and art, the camera bridges vision and reality."
			
			
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m3.jpg" alt="Sample Image">
        <p>
			"Every production is a masterpiece of collaboration.
			Cast and crew are the heartbeat of every successful story.
			Behind the scenes lies the true magic of teamwork and dedication.
			Together, they turn ideas into reality and visions into legacies.
			A business thrives when its team works like a well-directed set."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m4.jpg" alt="Sample Image">
        <p>
			"Editing is where the magic unfolds, frame by frame.
It’s the craft of shaping raw content into compelling narratives.
Every cut, transition, and effect breathes life into stories.
In business, polished visuals speak louder than words.
Video editing transforms imagination into a masterpiece."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/verticals/m5.jpg" alt="Sample Image">
        <p>
			"Advertising is storytelling with a purpose.
			An ad shoot brings brands to life, connecting them with audiences.
			From script to screen, every detail builds a memorable experience.
			Creativity, strategy, and passion come together in perfect harmony.
			Elevate your brand through visual artistry and storytelling brilliance."
        </p>
    </div>
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<!-- <div class="container p-4">
		<h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
			verticals
		  </h4>
		<div class="row">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-medkit service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hospital Management System
						</h6>
						<p class="text-muted">
							Health Care.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-dashboard service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Temple Management System
						</h6>
						<p class="text-muted">
							Religious. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-hotel service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hotel Management System
						</h6>
						<p class="text-muted">
							Restaurants. 
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							School Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							college Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-users service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Value Added Services
						</h6>
						<p class="text-muted">
							Bio metric Solutions.
							Bio metric Solutions.
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center icon-border">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
						Pawn
						</h6>
						<p class="text-muted">
							Chits Management.
							Jewellery Management.
							Bakery Management 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							<!-- Pawn Broking. 
							Whole Sale Management.
							Textile Management.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Furniture Management.
							Super market Management. 
						</p><br />
					</div>
				</div>
			</div>
		</div>
	</div> -->
</div>
